import { useAdminSignIn } from "../../Hooks/useAdminSignIn";

export default function SignInLink({
  className = "portal-btn portal-btn--primary",
  children = "Sign in",
  redirectTo = "/dashboard",
}) {
  const { signIn, pending, pendingLabel, error } = useAdminSignIn({
    redirectTo,
    notifyError: true,
  });

  return (
    <span className="portal-sign-in">
      <button
        type="button"
        className={className}
        disabled={pending}
        onClick={() => signIn().catch(() => {})}
      >
        {pending ? pendingLabel : children}
      </button>
      {error ? (
        <span className="portal-sign-in-error" role="alert">
          {error}
        </span>
      ) : null}
    </span>
  );
}
